export enum BillType {
  AutoPay = "AUTO_PAY",
  PayOnce = "PAY_ONCE",
}

export enum CurrencyCode {
  Usd = "USD",
  Cad = "CAD",
}

export enum BillCategory {
  Hdc1Dot0 = "HDC1DOT0",
  Hdc1Dot5 = "HDC1DOT5",
  Insurance = "INSURANCE",
}

export enum BillStatus {
  Failed = "FAILED",
  Ok = "OK",
  PastDue = "PAST_DUE",
}

type AlignedProductDetails = {
  category: BillCategory;
  productNumber?: string | null | undefined;
  formattedAmount: string;
  productDetails: Array<string>;
};

type VehicleKeyVal = {
  key: string;
  value: string;
};

type RevalVehicleDetails = {
  currentValue: string;
  id: string;
  make?: VehicleKeyVal | null;
  model?: VehicleKeyVal | null;
  newValue: string;
  year: string;
};

export type ApiBill = {
  id: string;
  type: BillType;
  category: BillCategory;
  productNumber?: string | null | undefined;
  formattedProductNumber?: string | null | undefined;
  amount: number;
  formattedAmount: string;
  nextPaymentDate?: string;
  expirationDate: string;
  currency: CurrencyCode;
  paymentUrl: string;
  productDetails: string[];
  informAboutStatus: boolean;
  status: BillStatus;
  total: {
    amount: number;
    formattedAmount: string;
  };
  revalOffer?: {
    currentPremium: string;
    endoNumber: string;
    endoStatus: string;
    newPremium: string;
    policyNumber: string;
    premiumDifference: string;
    vehicleValues?: Array<RevalVehicleDetails | null | undefined> | null;
  } | null;
  autoPayMethodDetails?:
    | {
        last4: string;
      }
    | null
    | undefined;
  alignedBill?: AlignedProductDetails | null;
  isSubmitted?: boolean;
};

export type Bill = ApiBill;

export type Billing = {
  bills: Bill[];
  outstandingBalance: number;
};
